




















































































































import {
  computed,
  ComputedRef,
  ref,
  defineComponent,
  watch,
  reactive,
  ComponentInstance,
  nextTick,
} from '@vue/composition-api';
import {
  LoadingIcon,
  LockOnIcon,
  CheckCircleFilledIcon,
  ErrorCircleFilledIcon,
  HelpCircleIcon,
  FileCopyIcon,
  InfoCircleFilledIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';
import { encode } from 'js-base64';

import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools/index';

import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';

interface SupwisdomForm extends ComponentInstance {
  clearValidate: Function;
  validate: Function;
  validateOnly: Function;
}

type FormKey =
  | 'appId'
  | 'appSecret'
  | 'dataEndpoint'
  | 'tokenEndpoint'
  | 'userInterFaceId'
  | 'departmentInterfaceId'
  | 'availableDepartmentId'
  | 'availableStatus'
  | string;

type FormData = Record<FormKey, string>;

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    initData: {
      requred: true,
      type: Object,
      default: () => {
        return {
          appId: '',
          appSecret: '',
          dataEndpoint: '',
          tokenEndpoint: '',
          userInterFaceId: '',
          departmentInterfaceId: '',
          availableDepartmentId: '',
          availableStatus: '',
        };
      },
    },
    testResult: {
      type: String,
      required: true,
      default: '',
    },
    testDetail: {
      type: Object,
      required: true,
      default: () => {
        return {
          showCount: false,
          departmentCount: 0,
          userCount: 0,
          departments: {
            length: 0,
            status: '',
          },
          users: {
            length: 0,
            status: '',
          },
        };
      },
    },
  },
  components: {
    LoadingIcon,
    LockOnIcon,
    CheckCircleFilledIcon,
    ErrorCircleFilledIcon,
    RemoveConfigConfirm,
    HelpCircleIcon,
    FileCopyIcon,
    InfoCircleFilledIcon,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    let supwisdomForm: SupwisdomForm | null = null;
    const isHideAvailableDepartmentId = ref(false);
    const isChangePassword = ref(false);
    const formData = reactive<FormData>({
      appId: '',
      appSecret: '',
      dataEndpoint: '',
      tokenEndpoint: '',
      userInterFaceId: '',
      departmentInterfaceId: '',
      availableDepartmentId: '',
      availableStatus: '',
    });
    // url格式校验成功
    const urlValidated = ref(true);

    const isSaving = ref(false); // 正在保存

    const stringKeys = [
      'appId',
      'appSecret',
      'dataEndpoint',
      'tokenEndpoint',
      'userInterFaceId',
      'departmentInterfaceId',
    ];
    const arrayKey = ['availableDepartmentId', 'availableStatus'];
    const formItemisEmpty = (key: string, value: any) => {
      if (stringKeys.includes(key)) {
        return value === '';
      }
      if (arrayKey.includes(key)) {
        return value.length === 0;
      }
    };

    const isCreate: ComputedRef<boolean> = computed(() =>
      Object.keys(props.initData).some(key => formItemisEmpty(key, props.initData[key])),
    );

    // 通用1-512位字符校验
    const stringRegex = /^[a-zA-Z0-9]{1,512}$/;
    // 通用id字符串校验
    const numberRegex = /^[a-zA-Z0-9]+(,[a-zA-Z0-9]+)*$/;
    // appSecret检验
    const secretRegex = /^[a-zA-Z0-9*]{1,512}$/;

    const rules = {
      appId: [
        {
          required: true,
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
        {
          validator: (val: string) => stringRegex.test(val),
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
      ],
      appSecret: [
        {
          required: true,
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
        {
          validator: (val: string) => secretRegex.test(val),
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
      ],
      dataEndpoint: [
        {
          required: true,
          message: i18n_t('仅支持url格式'),
          type: 'error',
        },
        {
          url: {
            protocols: ['http', 'https'],
            require_protocol: true,
          },
          message: i18n_t('仅支持url格式'),
          type: 'error',
        },
      ],
      tokenEndpoint: [
        {
          required: true,
          message: i18n_t('仅支持url格式'),
          type: 'error',
        },
        {
          url: {
            protocols: ['http', 'https'],
            require_protocol: true,
          },
          message: i18n_t('仅支持url格式'),
          type: 'error',
        },
      ],
      userInterFaceId: [
        {
          required: true,
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
        {
          validator: (val: string) => stringRegex.test(val),
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
      ],
      departmentInterfaceId: [
        {
          required: true,
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
        {
          validator: (val: string) => stringRegex.test(val),
          message: i18n_t('仅支持英文和数字输入，长度在1-512之间'),
          type: 'error',
        },
      ],
      availableDepartmentId: [
        {
          required: true,
          message: i18n_t('用于确认同步的部门范围，请使用英文逗号区隔不同部门的编号，如100000,900000'),
          type: 'error',
        },
        {
          validator: (val: string) => numberRegex.test(val),
          message: i18n_t('用于确认同步的部门范围，请使用英文逗号区隔不同部门的编号，如100000,900000'),
          type: 'error',
        },
      ],
      availableStatus: [
        {
          required: true,
          message: i18n_t('用于确认同步的用户身份类型，请使用英文逗号区隔不同类型用户，如910,101'),
          type: 'error',
        },
        {
          validator: (val: string) => numberRegex.test(val),
          message: i18n_t('用于确认同步的用户身份类型，请使用英文逗号区隔不同类型用户，如910,101'),
          type: 'error',
        },
      ],
    };

    const submitDisabled: ComputedRef<boolean> = computed(() => {
      const hasEmptyConfig = Object.values(formData).some(item => item === '');
      return hasEmptyConfig || props.testResult === 'testing' || !urlValidated.value;
    });

    const methods = {
      async copyText(text: string) {
        try {
          await copyText2Clipboard(text);
          tips.success(i18n_t('复制成功'));
        } catch (e: any) {
          tips.error(e);
        }
      },
      // 关闭弹窗时清空状态
      init() {
        isHideAvailableDepartmentId.value = false;
        isChangePassword.value = false;
        isSaving.value = false;
        Object.keys(formData).forEach(key => (formData[key] = ''));
      },
      // 编辑时回显数据
      initFormData() {
        if (!isCreate.value) {
          const copyData = _.cloneDeep(props.initData);
          isHideAvailableDepartmentId.value = copyData.isHideAvailableDepartmentId || false;
          delete copyData.isHideAvailableDepartmentId;
          Object.assign(formData, {
            ...copyData,
            availableDepartmentId: copyData.availableDepartmentId.join(','),
            availableStatus: copyData.availableStatus.join(','),
          });
        }
      },
      changePassword() {
        if (!isChangePassword.value) {
          formData.appSecret = '';
          isChangePassword.value = true;
        }
        methods.throttleValidateConfigForm();
      },
      rebackPassword() {
        if (formData.appSecret === '') {
          formData.appSecret = props.initData.appSecret;
          isChangePassword.value = false;
        }
      },
      onClose() {
        if (isSaving.value && props.testResult === 'success') {
          tips.info(i18n_t('后台保存中，请稍后查看'));
        }
        (supwisdomForm as SupwisdomForm).clearValidate();
        innerShow.value = false;
      },
      getFormDataConfig() {
        return {
          ...formData,
          availableDepartmentId: formData.availableDepartmentId.split(','),
          availableStatus: formData.availableStatus.split(','),
          appSecret: isChangePassword.value ? encode(formData.appSecret) : formData.appSecret,
        };
      },
      async testConfig() {
        const result = await (supwisdomForm as SupwisdomForm).validate();
        if (result === true) {
          context.emit('testConfig', {
            protocol: 'supwisdom',
            config: methods.getFormDataConfig(),
          });
        }
      },
      async saveConfig() {
        const result = await (supwisdomForm as SupwisdomForm).validate();
        if (result === true) {
          isSaving.value = true;
          context.emit('saveConfig', {
            protocol: 'supwisdom',
            config: methods.getFormDataConfig(),
          });
        }
      },
      confirmRemove() {
        context.emit('removeProtocol', 'supwisdom');
        innerShow.value = false;
      },
      throttleValidateConfigForm: _.throttle(() => {
        const isDiff = Object.keys(props.initData).some((key: FormKey) => props.initData[key] !== formData[key]);
        if (isDiff) {
          context.emit('update:testResult', '');
        }
      }, 500),
    };

    watch(
      () => innerShow.value,
      val => {
        methods.init();
        if (val) {
          methods.initFormData();
          nextTick(() => {
            supwisdomForm = context.refs.supwisdomForm as SupwisdomForm;
          });
        }
      },
    );

    // url字段单独获取一次校验结果 submitDisabled判断里用到
    watch(
      [() => formData.dataEndpoint, () => formData.tokenEndpoint],
      async () => {
        if (supwisdomForm) {
          const result = await supwisdomForm.validateOnly({
            fields: ['dataEndpoint', 'tokenEndpoint'],
            trigger: 'all',
          });
          urlValidated.value = result === true;
        }
      },
      { immediate: true },
    );

    return {
      innerShow,
      formData,
      isCreate,
      submitDisabled,
      isHideAvailableDepartmentId,
      isChangePassword,
      rules,
      ...methods,
    };
  },
});
